// extracted by mini-css-extract-plugin
export default {"img_lo":"loa_img_lo__pkwuY","loading":"loa_loading__QMdVG"};